// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrpoliciespg-inline-1 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.hrpoliciespg-inline-2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
}

.hrpoliciespg-inline-3 {
  padding: 0;
}

.hrpoliciespg-inline-4 {
  font-weight: 600;
}

.hrpoliciespg-inline-5 {
  font-size: 11px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hrpoliciespg-inline-6 {
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
}

.hrpoliciespg-inline-7 {
  color: #94a3b8;
  font-size: 11px;
}

.hrpoliciespg-inline-8 {
  display: flex;
  gap: 4px;
}

.hrpoliciespg-inline-9 {
  color: #ef4444;
}

.hrpoliciespg-dyn-1 {
  font-size: 13px;
  color: var(--hrpoliciespg-1-color);
}

.hrpoliciespg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--hrpoliciespg-2-color);
}

.hrpoliciespg-dyn-3 {
  text-align: center;
  padding: 30px;
  color: var(--hrpoliciespg-3-color);
}

.hrpoliciespg-dyn-4 {
  font-size: 11px;
  color: var(--hrpoliciespg-4-color);
}

.hrpoliciespg-dyn-5 {
  font-size: 10px;
  color: var(--hrpoliciespg-5-color);
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrPoliciesPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB","sourcesContent":[".hrpoliciespg-inline-1 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.hrpoliciespg-inline-2 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.hrpoliciespg-inline-3 {\n  padding: 0;\n}\n\n.hrpoliciespg-inline-4 {\n  font-weight: 600;\n}\n\n.hrpoliciespg-inline-5 {\n  font-size: 11px;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hrpoliciespg-inline-6 {\n  color: #2563eb;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.hrpoliciespg-inline-7 {\n  color: #94a3b8;\n  font-size: 11px;\n}\n\n.hrpoliciespg-inline-8 {\n  display: flex;\n  gap: 4px;\n}\n\n.hrpoliciespg-inline-9 {\n  color: #ef4444;\n}\n\n.hrpoliciespg-dyn-1 {\n  font-size: 13px;\n  color: var(--hrpoliciespg-1-color);\n}\n\n.hrpoliciespg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrpoliciespg-2-color);\n}\n\n.hrpoliciespg-dyn-3 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrpoliciespg-3-color);\n}\n\n.hrpoliciespg-dyn-4 {\n  font-size: 11px;\n  color: var(--hrpoliciespg-4-color);\n}\n\n.hrpoliciespg-dyn-5 {\n  font-size: 10px;\n  color: var(--hrpoliciespg-5-color);\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
